import { useEffect, useRef } from 'react';
import socketService from '../Utils/socket';
import useUserStore from '../Stores/UserStore';

export const useSocket = () => {
  const { token: storeToken } = useUserStore();
  const isInitialized = useRef(false);

  useEffect(() => {
    // Try to get token from store first, then localStorage
    let token = storeToken || localStorage.getItem('token');

    console.log('useSocket - Store token:', !!storeToken);
    console.log('useSocket - LocalStorage token:', !!localStorage.getItem('token'));
    console.log('useSocket - Using token:', !!token);

    if (token && !isInitialized.current) {
      console.log('useSocket - Connecting socket...');
      socketService.connect(token);
      isInitialized.current = true;
    } else if (!token) {
      console.warn('useSocket - No token available, socket will not connect');
    }

    return () => {
      // Don't disconnect on unmount, keep connection alive
      // socketService.disconnect();
    };
  }, [storeToken]);

  return socketService;
};

export default useSocket;

